module.exports = __webpack_public_path__ + "img/sidebar-room-capacity.d39761d4.svg";